import { render, staticRenderFns } from "./schedulePhase_match_list.vue?vue&type=template&id=52eba02c&scoped=true"
import script from "./schedulePhase_match_list.vue?vue&type=script&lang=js"
export * from "./schedulePhase_match_list.vue?vue&type=script&lang=js"
import style0 from "./schedulePhase_match_list.vue?vue&type=style&index=0&id=52eba02c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52eba02c",
  null
  
)

export default component.exports